import React, { FC } from "react";
import { PriceRangeSlider } from "./PriceRangeSlider";
import { FilteringItem } from "./FilteringItem";
import { IFilteringItem, IPriceRangeSlider } from "./types";

interface Props extends IPriceRangeSlider, IFilteringItem {}

export const PriceRangeSliderFilteringItem: FC<Props> = ({
  label,
  icon,
  ...props
}) => (
  <FilteringItem label={label} icon={icon}>
    <PriceRangeSlider {...props} />
  </FilteringItem>
);
